<template>
  <b-table-simple aria-colcount="6" responsive hover small no-border-collapse class="table-acumulats">
    <b-thead>
      <b-tr class="custom-row">
        <b-th aria-colindex="1" class="capcalera-enunciat custom-cell"></b-th>
        <b-th aria-colindex="2" class="capcalera-taula custom-cell">Cat.</b-th>
        <b-th aria-colindex="3" class="capcalera-taula custom-cell">Acu.</b-th>
        <b-th aria-colindex="4" class="capcalera-mesos custom-cell">{{
          $t("variables.mesos." + mesos[0])
        }}</b-th>
        <b-th aria-colindex="5" class="capcalera-mesos custom-cell">{{
          $t("variables.mesos." + mesos[1])
        }}</b-th>
        <b-th aria-colindex="6" class="capcalera-mesos custom-cell">{{
          $t("variables.mesos." + mesos[2])
        }}</b-th>
      </b-tr>
    </b-thead>
    <!--Taula preguntes comunes-->
    <b-tbody v-if="!esSatisfaccioFidelitat && !esPreguntaEspecifica">
      <b-tr
        class="custom-row"
        v-for="(item, idx) of data"
        :key="'questio - ' + idx"
      >
        <b-td
          class="custom-cell enunciat"
          @click="seleccionarPregunta(idx)"
          :class="{
            'pregunta-seleccionada': preguntaSeleccionadaGlobal === idx,
          }"
          ref="preguntaRef"
          >{{ item.enunciat }}</b-td
        >
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.catalunya),
            'percentatge-neutral': comprovarNeutral(item.catalunya),
            'percentatge-negatiu': comprovarNegatiu(item.catalunya),
          }"
          >{{ item.catalunya }}%</b-td
        >
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.acumulat),
            'percentatge-neutral': comprovarNeutral(item.acumulat),
            'percentatge-negatiu': comprovarNegatiu(item.acumulat),
          }"
          >{{ item.acumulat }}%</b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior2),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior2),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior2),
            'percentatge-buit': comprovarBuit(item.mesAnterior2),
          }"
          ><template
            v-if="
              item.mesAnterior2 !== null &&
                item.mesAnterior2 !== undefined &&
                item.mesAnterior2 !== ''
            "
          >
            {{ item.mesAnterior2 }}%
          </template></b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior1),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior1),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior1),
            'percentatge-buit': comprovarBuit(item.mesAnterior1),
          }"
          ><template
            v-if="
              item.mesAnterior1 !== null &&
                item.mesAnterior1 !== undefined &&
                item.mesAnterior1 !== ''
            "
          >
            {{ item.mesAnterior1 }}%
          </template></b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mes),
            'percentatge-neutral': comprovarNeutral(item.mes),
            'percentatge-negatiu': comprovarNegatiu(item.mes),
            'percentatge-buit': comprovarBuit(item.mes),
          }"
        >
          <template
            v-if="
              item.mes !== null && item.mes !== undefined && item.mes !== ''
            "
          >
            {{ item.mes }}%
          </template>
        </b-td>
      </b-tr>
    </b-tbody>
    <!--Taula preguntes especifiques-->
    <b-tbody v-else-if="!esSatisfaccioFidelitat && esPreguntaEspecifica">
      <b-tr
        class="custom-row"
        v-for="(item, idx) of data"
        :key="'questio - ' + (idx + 6)"
      >
        <b-td
          class="custom-cell enunciat"
          @click="seleccionarPregunta(idx + 6)"
          :class="{
            'pregunta-seleccionada': preguntaSeleccionadaGlobal === idx + 6,
          }"
          ref="preguntaRef"
          >{{ item.enunciat }}
        </b-td>
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.catalunya),
            'percentatge-neutral': comprovarNeutral(item.catalunya),
            'percentatge-negatiu': comprovarNegatiu(item.catalunya),
          }"
        >
          {{ item.catalunya }}%</b-td
        >
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.acumulat),
            'percentatge-neutral': comprovarNeutral(item.acumulat),
            'percentatge-negatiu': comprovarNegatiu(item.acumulat),
          }"
          >{{ item.acumulat }}%</b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior2),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior2),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior2),
            'percentatge-buit': comprovarBuit(item.mesAnterior2)
          }"
        >
          <template
            v-if="
              item.mesAnterior2 !== null &&
                item.mesAnterior2 !== undefined &&
                item.mesAnterior2 !== ''
            "
          >
            {{ item.mesAnterior2 }}%
          </template>
        </b-td>
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior1),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior1),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior1),
            'percentatge-buit': comprovarBuit(item.mesAnterior1)
          }"
        >
          <template
            v-if="
              item.mesAnterior1 !== null &&
                item.mesAnterior1 !== undefined &&
                item.mesAnterior1 !== ''
            "
          >
            {{ item.mesAnterior1 }}%
          </template>
        </b-td>
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mes),
            'percentatge-neutral': comprovarNeutral(item.mes),
            'percentatge-negatiu': comprovarNegatiu(item.mes),
            'percentatge-buit': comprovarBuit(item.mes),
          }"
        >
        <template
            v-if="
              item.mes !== null &&
                item.mes !== undefined &&
                item.mes !== ''
            "
          >
            {{ item.mes }}%
          </template>
        </b-td>
      </b-tr>
    </b-tbody>
    <!--Taula preguntes Satisfaccio i Fidelitat-->
    <b-tbody v-else>
      <b-tr
        class="custom-row"
        v-for="(item, idx) of data"
        :key="'questio - ' + (idx + 14)"
      >
        <b-td
          class="custom-cell enunciat"
          @click="seleccionarPregunta(idx + 14)"
          :class="{
            'pregunta-seleccionada': preguntaSeleccionadaGlobal === idx + 14,
          }"
          ref="preguntaRef"
          >{{ item.enunciat }}</b-td
        >
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.catalunya),
            'percentatge-neutral': comprovarNeutral(item.catalunya),
            'percentatge-negatiu': comprovarNegatiu(item.catalunya),
          }"
        >
          {{ item.catalunya }}</b-td
        >
        <b-td
          class="catalunya-acumulat custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.acumulat),
            'percentatge-neutral': comprovarNeutral(item.acumulat),
            'percentatge-negatiu': comprovarNegatiu(item.acumulat),
          }"
          >{{ item.acumulat }}</b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior2),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior2),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior2),
            'percentatge-buit': comprovarBuit(item.mesAnterior2)
          }"
          >{{ item.mesAnterior2 }}</b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mesAnterior1),
            'percentatge-neutral': comprovarNeutral(item.mesAnterior1),
            'percentatge-negatiu': comprovarNegatiu(item.mesAnterior1),
            'percentatge-buit': comprovarBuit(item.mesAnterior1)
          }"
          >{{ item.mesAnterior1 }}</b-td
        >
        <b-td
          class="custom-cell"
          :class="{
            'percentatge-positiu': comprovarPositiu(item.mes),
            'percentatge-neutral': comprovarNeutral(item.mes),
            'percentatge-negatiu': comprovarNegatiu(item.mes),
            'percentatge-buit': comprovarBuit(item.mes),
          }"
        >
          {{ item.mes }}
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
  data() {
    return {
      esPositiu: false,
      esNeutral: false,
      esNegatiu: false,
      preguntaSeleccionada: 0,
      preguntaAnterior: null,
    };
  },
  props: {
    data: {
      type: Array,
    },
    mesos: {
      type: Array,
    },
    esSatisfaccioFidelitat: {
      type: Boolean,
    },
    esPreguntaEspecifica: {
      type: Boolean,
    },
    preguntaSeleccionadaGlobal: {
      type: Number,
    },
  },
  methods: {
    comprovarPositiu(item) {
      if (this.esSatisfaccioFidelitat) {
        if (item >= 8.0) {
          return true;
        }
      } else {
        if (item >= 90) {
          return true;
        }
      }
    },
    comprovarNeutral(item) {
      if (this.esSatisfaccioFidelitat) {
        return false;
      } else {
        if (item < 90 && item > 75) {
          return true;
        }
      }
    },
    comprovarNegatiu(item) {
      if (this.esSatisfaccioFidelitat) {
        if (item < 8.0) {
          return true;
        }
      } else {
        if (item <= 75) {
          return true;
        }
      }
    },
    comprovarBuit(item) {
      if (item == null || item == "") {
        return true;
      }
    },
    seleccionarPregunta(index) {
      //Logica per veure la pregunta seleccionada amb les classes corresponents entre les 3 taules i que no es veguin multiples preguntes seleccionades
      // Si hi ha una pregunta seleccionada previament, li treiem la classe
      if (this.preguntaSeleccionada !== null) {
        if (
          this.$refs["pregunta"] &&
          this.$refs["pregunta"][this.preguntaSeleccionada]
        ) {
          this.$refs["pregunta"][this.preguntaSeleccionada].classList.remove(
            "pregunta-seleccionada"
          );
        }
      }

      // Establim la pregunta anterior com la pregunta seleccionada actual
      this.preguntaAnterior = this.preguntaSeleccionada;

      // Establim la nova pregunta seleccionada
      this.preguntaSeleccionada = index;

      // Afegim la clase a la pregunta actual
      if (this.$refs["pregunta"] && this.$refs["pregunta"][index]) {
        this.$refs["pregunta"][index].classList.add("pregunta-seleccionada");
      }

      // Si hi ha una pregunta anterior, restaurar el seu color de fons original
      if (this.preguntaAnterior !== null) {
        if (
          this.$refs["pregunta"] &&
          this.$refs["pregunta"][this.preguntaAnterior]
        ) {
          this.$refs["pregunta"][this.preguntaAnterior].classList.remove(
            "pregunta-seleccionada"
          );
        }
      }

      this.$emit("pregunta-seleccionada", index);
    },
  },
};
</script>
<style scoped>
@media (min-width: 768px) {
  .custom-row {
    height: 20px;
  }

  .custom-cell {
    padding-top: 5px;
    padding-bottom: 5px;
    width: 150px;
  }
  .table-acumulats {
    width: 800px;
  }

  .capcalera-enunciat {
    width: 400px;
  }
}
.enunciat {
  text-align: left;
  font-size: 14px;
}

.percentatge-positiu {
  background-color: #00ab84;
  color: white;
  font-weight: lighter;
}

.percentatge-neutral {
  background-color: #e1d906;
  font-weight: lighter;
}

.percentatge-negatiu {
  background-color: #f4364c;
  color: white;
  font-weight: lighter;
}

.percentatge-buit {
  background-color: white;
}

.catalunya-acumulat {
  font-weight: bold;
  font-size: 14px;
}

.capcalera-mesos {
  font-weight: normal;
  font-style: italic;
  font-size: 14px;
}

.capcalera-taula {
  font-size: 14px;
}

.pregunta-seleccionada {
  background-color: rgb(218, 202, 202);
}
</style>
